import CreditsService from './credits-service';

export default {
  namespaced: true,

  state: {
    credits: 0,
    watchers: [],
    initializing: false,
    premium: false,
    expiresAt: null,
  },

  getters: {
    loading: (state) => state.loading,
    premium: (state) => state.premium,
    expiresAt: (state) => state.expiresAt,
    credits: (state) => state.credits,
    initializing: (state) => state.initializing,

    hasFunds(state, getters) {
      return getters.premium || (state.credits || 0) > 0;
    },
  },

  mutations: {
    status(state, { premium, credits, expiresAt }) {
      state.premium = premium;
      state.credits = credits;
      state.expiresAt = expiresAt;
    },

    addWatcher(state, payload) {
      state.watchers.push(payload);
    },

    removeWatchers(state) {
      state.watchers = [];
    },

    credits(state, payload) {
      state.credits = +payload;
    },
  },

  actions: {
    clear({ dispatch }) {
      dispatch('removeWatchers');
    },

    setup({ state, dispatch }) {
      state.initializing = true;

      return Promise.all([dispatch('watchForCredits')])
        .then(() => {
          state.initializing = false;
        })
        .catch((error) => {
          state.initializing = false;
          return Promise.reject(error);
        });
    },

    watchForCredits({ commit, dispatch, rootGetters }) {
      return new Promise((resolve, reject) => {
        let responded = false;

        if (!rootGetters['auth/currentUser']) {
          resolve();
          return;
        }

        const watcher = CreditsService.watchForCredits(
          rootGetters['auth/currentUser'],
          (status) => {
            commit('status', status);

            if (!responded) {
              resolve();
            }

            responded = true;
          },
          (error) => {
            dispatch(
              'core/error',
              { error },
              { root: true },
            );

            if (!responded) {
              reject(error);
            }

            responded = true;
          },
        );

        commit('addWatcher', watcher);
      });
    },

    removeWatchers({ state, commit }) {
      state.watchers.forEach((watcher) =>
        CreditsService.killWatcher(watcher),
      );

      commit('removeWatchers');
    },
  },
};
